import * as React from "react";
import styled from "styled-components";

const LoadingSpin = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);

	.spinner {
		&:after {
			width: 2.88em;
			height: 2.88em;
			top: calc(50% - (2.88em / 2));
			left: calc(50% - (2.88em / 2));
		}
	}
`;

const Loading: React.FC<{ children: React.ReactNode }> = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	return (
		<LoadingSpin>
			<div role="alert" className="spinner mb-6 h-3 w-3 pb-2" />
			{children}
		</LoadingSpin>
	);
};

export default Loading;
